import ChartInfo from "./chartInfo";

export default class Fund {
    public id: number;
    public name: string;
    public description: string;
    public canHoldLumpSum: boolean;
    public defaultChartInfo: ChartInfo;

    public constructor(id: number, name: string, description: string, canHoldLumpSum: boolean, defaultChartInfo: ChartInfo) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.canHoldLumpSum = canHoldLumpSum;
        this.defaultChartInfo = defaultChartInfo;
    }
}
